module.exports = __webpack_public_path__ + "img/position-tower.b7e1f606.png";